import React from "react";
import HeroLayout from "./HeroLayout";
import FooterLayout from "./FooterLayout";
import { APP_STORE_URL, PLAY_STORE_URL } from "./links";

/**
 * The "Install The Free App" block (#1088): one component for home (`/`),
 * `/free-trial` and `/app`, replacing the near-copies that each page carried.
 *
 * - `layout="hero"`: the home page block (icon, headline, INSTALL THE APP on
 *   phones and tablets, store badges, phone-skin carousel). `/` and `/app`.
 * - `layout="footer"`: the smaller block at the foot of `/free-trial`, which
 *   has no button and no carousel.
 * - `links="store"`: direct App Store / Google Play URLs, the only mode since
 *   #1264 took the website off smart.link (its links sent phones to the
 *   sign-up page, not a store).
 */
export type InstallAppProps =
  | {
      layout: "hero";
      links: "store";
      /** A line under the headline (/app: "Watch Anytime. Watch Anywhere."). */
      subline?: string;
    }
  | {
      layout: "footer";
    };

const InstallApp = (props: InstallAppProps) => {
  if (props.layout === "footer") {
    return <FooterLayout />;
  }

  const hrefs = {
    ios: APP_STORE_URL,
    android: PLAY_STORE_URL,
    appStore: APP_STORE_URL,
    playStore: PLAY_STORE_URL,
  };

  return <HeroLayout hrefs={hrefs} subline={props.subline} />;
};

export default InstallApp;
